
import React from 'react';

import { Link } from 'react-router-dom';

function WhatIsDeclaration() {
  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen font-sans">
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 py-16">
            <h1 className="text-3xl md:text-4xl font-bold text-[#102A43] mb-6">AASC Accountability Declaration</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Publicly verifiable proof that your organization uses AI responsibly.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-12 space-y-12">
          
          <section className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
            <h2 className="text-2xl font-bold text-[#102A43] mb-6 border-b border-gray-100 pb-4">What This Signal Means</h2>
            <div className="space-y-4 text-[#64748B] leading-relaxed">
              <p>
                <strong>Confirms Documented Conformance:</strong> The declaration indicates that the organization has committed to and aligned with AASC standards at a specific point in time.
              </p>
              <p>
                <strong>Does Not Guarantee Outcomes:</strong> It is an attestation of operational methodology, not a warranty of specific project results or error-free performance.
              </p>
              <p>
                <strong>Conditional and Revocable:</strong> Status is maintained only through continued adherence to standards. It can be suspended or withdrawn if the organization fails to maintain controls.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#102A43] mb-6">Who This Is For</h2>
            <div className="bg-blue-50 border-l-4 border-[#2F80ED] p-6">
              <p className="text-[#2F80ED] font-medium text-lg">
                Any organization using AI.
              </p>
              <p className="text-blue-800 mt-2">
                This includes Organizations, Systems Integrators, and Managed Service Providers who are responsible for the safe operation of internal or client workflows.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#102A43] mb-6">What the Declaration Requires</h2>
            <div className="grid gap-6 md:grid-cols-2">
              {[
                "Documented Responsibility Domains",
                "Defined Scope Boundaries",
                "Escalation and Kill Switch Procedures",
                "Client Disclosure Requirements",
                "Pre-Deployment Testing Documentation",
                "Incident Response Procedures",
                "Data Handling and Retention Policies",
                "Change Notification Procedures"
              ].map((req, index) => (
                <div key={index} className="bg-white p-6 border border-gray-200 rounded-sm shadow-sm flex items-start gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-[#2F80ED] text-white rounded-full font-bold text-sm">
                    {index + 1}
                  </span>
                  <span className="font-medium text-[#102A43]">{req}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="bg-gray-100 p-8 rounded-sm border border-[#E2E8F0]">
            <h2 className="text-2xl font-bold text-[#102A43] mb-4">Enforcement and Conditional Status</h2>
            <p className="text-[#64748B] mb-4">
              The Declaration is not a permanent award. It is a revocable status. The Council actively monitors registry status and investigates complaints.
            </p>
            <ul className="list-disc pl-5 space-y-2 text-[#64748B] mb-6">
              <li><strong>Suspension:</strong> May occur during investigation of valid complaints.</li>
              <li><strong>Withdrawal:</strong> Will occur for confirmed misrepresentation, failure to maintain controls, or failure to disclose material changes.</li>
            </ul>
          </section>

          <section className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
            <h2 className="text-2xl font-bold text-[#102A43] mb-6 text-red-700">What the Declaration Does NOT Attest To</h2>
            <ul className="space-y-3 text-[#64748B]">
              <li className="flex gap-3"><span className="text-red-500 font-bold">✕</span>Compliance with government regulations (e.g., EU AI Act).</li>
              <li className="flex gap-3"><span className="text-red-500 font-bold">✕</span>The creative quality or business value of the organization's work.</li>
              <li className="flex gap-3"><span className="text-red-500 font-bold">✕</span>Financial solvency or business stability.</li>
              <li className="flex gap-3"><span className="text-red-500 font-bold">✕</span>Security of the underlying foundation models (e.g., OpenAI, Anthropic).</li>
            </ul>
          </section>

          <div className="flex justify-center pt-8">
            <Link to="/apply" className="px-8 py-4 bg-[#2F80ED] text-white font-bold rounded-sm hover:bg-[#2563eb] transition-colors">
              Start Your Declaration
            </Link>
          </div>

        </div>
      </div>
    </>
  );
}

export default WhatIsDeclaration;
